import {
  IEstimatesTcoSelections,
  IEstimatesWithTcoSelectionsRequest,
} from 'types';
import { queryKeys } from 'utils';
import { estimatesWithTcoSelectionsRequest } from 'utils/api/estimatesWithTcoSelectionsRequest';
import { useGenerateQuery } from './useGenerateQuery';

export const useGetTcoDeviceSelectionsEstimates = (
  requestConfig: IEstimatesWithTcoSelectionsRequest = {}
) => {
  const { params } = requestConfig;
  return useGenerateQuery<IEstimatesTcoSelections[]>({
    queryKey: params
      ? queryKeys(params).filter.tcoEstimatesDeviceSelections
      : queryKeys().all.tcoEstimatesDeviceSelections,
    apiCall: estimatesWithTcoSelectionsRequest,
    requestConfig,
  });
};
